import React from "react";

const Goals = ({ listOfGoals }) => {
    return (
        <section className="project-goal">
            <div className="container">
                <h2 className="section-title">Project Goals</h2>
                <ul className="project-goals">
                    {listOfGoals.map((goal, index) => {
                        return (<li key={index}>{goal}</li>);
                    })}
                </ul>
            </div>
        </section>
    )
};

export default Goals;